import React from 'react';
import { useParams } from 'react-router-dom';
import { isTeamManager, hasMyTeamsAccess } from 'utils/privileges';
import ErrorScreen from '../pages/errors/ErrorScreen';
function TeamAccessWrapper(_ref) {
  var _ref$getAdditionalPer = _ref.getAdditionalPermissions,
    getAdditionalPermissions = _ref$getAdditionalPer === void 0 ? function () {
      return true;
    } : _ref$getAdditionalPer,
    children = _ref.children;
  var _useParams = useParams(),
    teamId = _useParams.teamId;
  var hasAdditionalPermissions = getAdditionalPermissions();

  // This only applies if the current page is scoped to a team
  var userManagesThisTeam = Boolean(teamId && isTeamManager(teamId));
  if (userManagesThisTeam || hasMyTeamsAccess() && hasAdditionalPermissions) {
    return children;
  }
  return /*#__PURE__*/React.createElement(ErrorScreen, {
    reason: "NOT_TEAM_MANAGER"
  });
}
export default TeamAccessWrapper;